import { formatNumber } from 'utils/format-number'
import { resetTimer } from 'utils/handle-featured-timer'
import { MarketBrief } from 'models/market'

const getCurrencyRatesByIndex = (payload: MarketBrief[], currencyIndex: string) =>
  payload.find((el) => el.pair === currencyIndex)

const isCurrencyDataInPayload = (payload: MarketBrief[], currencyIndex: string): boolean =>
  !!getCurrencyRatesByIndex(payload, currencyIndex) || false

const updateRateTrend = (actualRate: number, previousRate: number, $trendElement: HTMLSpanElement): void => {
  if ($trendElement) {
    $trendElement.classList.remove('is-up')
    $trendElement.classList.remove('is-down')

    if (actualRate !== previousRate) {
      $trendElement.classList.add(actualRate > previousRate ? 'is-up' : 'is-down')
    }
  }
}

const updateRate = (direction: string, rate: MarketBrief, $singleRateElement: HTMLDivElement): void => {
  const actualRate = direction === 'bid' ? rate.bestOffers.bid_now : rate.bestOffers.ask_now
  const previousRate = direction === 'bid' ? rate.bestOffers.bid_old : rate.bestOffers.ask_old

  const $rateElement = $singleRateElement.querySelector<HTMLSpanElement>('[data-rate-value]')
  const $trendElement = $singleRateElement.querySelector<HTMLSpanElement>('[data-rate-trend]')

  $rateElement.innerHTML = `${formatNumber(actualRate || 0, 4)} PLN`

  updateRateTrend(actualRate, previousRate, $trendElement)
}

const updateWidgetUI = ($element: HTMLDivElement, currencyIndex: string, payload): void => {
  if (!isCurrencyDataInPayload(payload, currencyIndex)) return
  const $directionFragments = $element.querySelectorAll<HTMLDivElement>('[data-rate-direction]')
  $directionFragments.forEach(($singleRateElement) => {
    updateRate(
      $singleRateElement.dataset.rateDirection,
      getCurrencyRatesByIndex(payload, currencyIndex),
      $singleRateElement,
    )
  })
}

export function handleFeaturedRatesUpdate(payload: MarketBrief[]): void {
  const $rateElements = document.querySelectorAll<HTMLDivElement>('[data-currency-index]')
  $rateElements.forEach(($singleRateElement) => {
    const currencyIndex = $singleRateElement.dataset.currencyIndex
    updateWidgetUI($singleRateElement, currencyIndex, payload)
  })
  resetTimer()
}
